import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';

import Login from './components/Login';
import ErrorBoundary from './components/ErrorBoundary';
import GuardProfesionalRegistrado from './components/GuardProfesionalRegistrado';
import Navbar from './components/Navbar';
import Navbar_fijo from './components/Navbar_fijo';
import NavbarHome from './components/NavbarHome';
import NavbarCita from './components/NavbarCita';
import Sidebar from './components/Sidebar';
import Sidebar_profesional from './components/Sidebar_profesional.js';
import Sidebar_fijo from './components/Sidebar_fijo';
import Footer from './components/Footer';
import Home from './pages/Home';
import Sedes from './pages/Sedes';
import Convenios from './pages/Convenios';
import Citas from './pages/Citas';
import Citas_pacientes from './pages/Citas_pacientes';
import Agendas from './pages/Agendas';
import Agenda_profesional from './pages/Agendas_profesional.js';
import Agenda_profesional_2 from './pages/Agenda_profesional_2.js';
import Consultas_urg from './pages/Consultas_urg';
import Consultas_programada from './pages/Consultas_programada';
import Tablero_RDA from './pages/Tablero_RDA.js';
import Facturacion from './pages/Facturacion.js';
import ContratosAdd from './pages/ContratosAdd.js';
import ContratosEdit from './pages/ContratosEdit.js';
import Perfil from './pages/Perfil.js';
import Publicaciones from './pages/Publicaciones';
import Publicaciones_prestador from './pages/Publicaciones_prestador';
import Ajustes from './pages/Ajustes.js';
import ConfigHistoriaClinica from './pages/ConfigHistoriaClinica.js';
import HistoriasClinicasConfiguradas from './pages/HistoriasClinicasConfiguradas.js';
import Contratos from './pages/Contratos';
import Consentimientos from './pages/Consentimientos';
import Cuota_Moderadora from './pages/Cuota_Moderadora';
import Crear_Usuarios from './pages/Crear_Usuarios';
import Servicios from './pages/Servicios';
import Servicios_facturacion from './pages/Servicios_facturacion.js';
import Horarios_Atencion from './pages/Horarios_Atencion';
import Crear_Cuenta from './pages/Crear_Cuenta';
import Cambiar_Contraseña from './pages/CambiarContraseña';
import Detalle_compra from './pages/Detalle_compra';
import Activar_membresia from './pages/Activar_membresia';
import Informes from './pages/Informes.js';
import InformeFacturas from './pages/InformeFacturas.js';
import ReporteFacturacion from './pages/ReporteFacturacion.js';
import CuentasCobro from './pages/CuentasCobro.js';
import Anexos from './pages/Anexos.js';
import Demonio_MedicallCommerce from './pages/Demonio_MedicallCommerce.js';
import Error_404 from './pages/Error404';
import './tools/css/App.css';
import Navbar2 from './components/Navbar2';
import icono from './tools/images/icono.svg';

import Pagos_sumitech from './pages/Pagos_sumitech.js';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';


function App (){

    return (
        <BrowserRouter>


            <ErrorBoundary>
            <Switch>

                  <Route exact path="/">
                    <ReactNotifications/>
                    <Login/>
                  </Route>
                  
                  <Route  path="/home">
                    <ReactNotifications/>
                    <NavbarHome/>  
                    <Sidebar/>                
                    <Home/>
                    <Footer/>                   
                  </Route>                       
                  

                  <Route  path="/convenios">
                    <ReactNotifications/>
                    <Navbar/>    
                    <Sidebar_profesional/>            
                    <Convenios/>
                    <Footer/>
                  </Route>

                  <Route  path="/citas">
                    <ReactNotifications/>
                    <NavbarCita/>
                    <Sidebar/>                
                    <Citas/>
                    <Footer/>
                  </Route>

                  <Route  path="/citas_profesional">
                    <ReactNotifications/>
                    <NavbarCita/>
                    <Sidebar_profesional/>                 
                    <Citas/>
                    <Footer/>
                  </Route>

                  <Route  path="/citas/pacientes">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar/>               
                    <Citas_pacientes/>
                    <Footer/>
                  </Route>

                  <Route  path="/agendas">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar_profesional/>               
                    <Agendas/>
                    <Footer/>
                  </Route>

                  <Route  path="/agenda_profesional">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar_profesional/>
                    <GuardProfesionalRegistrado>
                      <Agenda_profesional/>
                    </GuardProfesionalRegistrado>
                    <Footer/>
                  </Route>

                  <Route  path="/agenda_profesional_2">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar_profesional/>               
                    <Agenda_profesional_2/>
                    <Footer/>
                  </Route>

                  <Route  path="/consultas_realizadas">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar_profesional/>               
                    <Consultas_urg/>
                    <Footer/>
                  </Route>

                  <Route  path="/tablero_RDA">
                    <ReactNotifications/>
                    <Navbar/> 
                    <Sidebar_profesional/>                 
                    <Tablero_RDA/>
                    <Footer/>
                  </Route>

                  <Route  path="/consultas_programadas">
                    <ReactNotifications/>
                    <Navbar/> 
                    <Sidebar_profesional/>                 
                    <Consultas_programada/>
                    <Footer/>
                  </Route>

                  <Route  path="/facturacion">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar_profesional/>
                    <Facturacion/>
                    <Footer/>
                  </Route>

                  <Route  path="/informes_facturas">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar_profesional/>
                    <InformeFacturas/>
                    <Footer/>
                  </Route>

                  <Route  path="/reporte_facturacion">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar_profesional/>
                    <ReporteFacturacion/>
                    <Footer/>
                  </Route>

                  <Route  path="/cuentas_cobro">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar_profesional/>
                    <CuentasCobro/>
                    <Footer/>
                  </Route>

                  <Route  path="/anexos_institucion">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar_profesional/>
                    <Anexos/>
                    <Footer/>
                  </Route>

                  <Route  path="/crear/contratos">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar/>               
                    <ContratosAdd/>
                    <Footer/>
                  </Route>                

                  <Route  path="/perfil">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar_profesional/>              
                    <Perfil/>
                    <Footer/>
                  </Route>

                  <Route  path="/inicio">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar/>                
                    <Publicaciones/>
                    <Footer/>
                  </Route>

                  <Route  path="/inicio_profesional">
                    <ReactNotifications/>
                    <NavbarHome/>  
                    <Sidebar_profesional/>                
                    <Publicaciones/>
                    <Footer/>                   
                  </Route>

                  <Route  path="/publicaciones">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar_profesional/>                
                    <Publicaciones_prestador/>
                    <Footer/>
                  </Route>

                  <Route  path="/ajustes">
                    <ReactNotifications/>
                    <Navbar/>
                    <Ajustes/>
                    <Sidebar_profesional/>
                    <Footer/>
                  </Route>

                  <Route  path="/config_historia_clinica">
                    <ReactNotifications/>
                    <Navbar/>
                    <ConfigHistoriaClinica/>
                    <Sidebar_profesional/>
                    <Footer/>
                  </Route>

                  <Route  path="/historias_clinicas_configuradas">
                    <ReactNotifications/>
                    <Navbar/>
                    <HistoriasClinicasConfiguradas/>
                    <Sidebar_profesional/>
                    <Footer/>
                  </Route>

                  <Route  path="/contratos">
                    <ReactNotifications/>
                    <Navbar/>    
                    <Sidebar_profesional/>           
                    <Contratos/>
                    <Footer/>
                  </Route>

                  <Route  path="/editar/contratos">
                    <ReactNotifications/>
                    <Navbar/>   
                    <Sidebar/>              
                    <ContratosEdit/>
                    <Footer/>
                  </Route>

                  <Route  path="/consentimientos">
                    <ReactNotifications/>
                    <Navbar/>         
                    <Sidebar_profesional/>       
                    <Consentimientos/>
                    <Footer/>
                  </Route>

                  <Route  path="/cuotasmoderadoras">
                    <ReactNotifications/>
                    <Navbar/> 
                    <Sidebar_profesional/>                 
                    <Cuota_Moderadora/>
                    <Footer/>
                  </Route>

                  <Route  path="/crear_usuarios">
                    <ReactNotifications/>
                    <Navbar/>   
                    <Sidebar_profesional/>               
                    <Crear_Usuarios/>
                    <Footer/>
                  </Route>

                  <Route  path="/servicios">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar_profesional/>               
                    <Servicios/>
                    <Footer/>
                  </Route>

                  <Route  path="/servicios_facturacion">
                    <ReactNotifications/>
                    <Navbar/>  
                    <Sidebar_profesional/>               
                    <Servicios_facturacion/>
                    <Footer/>
                  </Route>

                  <Route  path="/horarios">
                    <ReactNotifications/>
                    <Navbar/> 
                    <Sidebar_profesional/>               
                    <Horarios_Atencion/>
                    <Footer/>
                  </Route>

                  <Route  path="/sedes">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar_profesional/>                  
                    <Sedes/>
                    <Footer/>
                  </Route>

                  <Route  path="/informes">
                    <ReactNotifications/>
                    <Navbar/>
                    <Sidebar/>                  
                    <Informes/>
                    <Footer/>
                  </Route>

                  <Route  path="/crear_cuenta">         
                   <ReactNotifications/>
                   <Crear_Cuenta/>                   
                  </Route>

                  <Route  path="/pagos_WebServer">         
                   <ReactNotifications/>
                   <Pagos_sumitech/>                   
                  </Route>

                  <Route  path="/recover_password">         
                    <ReactNotifications/>
                    <Cambiar_Contraseña/>                   
                  </Route>  
 
                  <Route  path="/detalle_compra">                   
                    <Detalle_compra/>                   
                  </Route>

                  <Route  path="/detalle_compra_commerce">                   
                    <Demonio_MedicallCommerce/>                   
                  </Route>

                  <Route  path="/activationMembership">         
                   <ReactNotifications/>
                   <Activar_membresia/>                   
                  </Route>

                  <Route  path="**">         
                   <ReactNotifications/>
                   <Error_404/>                   
                  </Route>

              
            </Switch>
            </ErrorBoundary>


        </BrowserRouter>

        

    );
}

export default App;